export default __webpack_public_path__ + "static/media/KaiNexus.687c1d99.png";